'use client';

import {
  type Dispatch,
  type PropsWithChildren,
  type ReactElement,
  type SetStateAction,
  createContext,
  useState,
} from 'react';

type QuizProgress = [number, Dispatch<SetStateAction<number>>];

export const QuizProgressContext = createContext<QuizProgress | null>(null);

type Props = PropsWithChildren<{ startingStep: number }>;

export const QuizProgressProvider = (props: Props): ReactElement => {
  const { children, startingStep } = props;

  const stepState = useState<number>(startingStep);

  return (
    <QuizProgressContext.Provider value={stepState}>
      {children}
    </QuizProgressContext.Provider>
  );
};
